import "./assets/main.css"

import ui from "@nuxt/ui/vue-plugin"
import { createDashboardApp } from "./utils/create-dashboard-app"

const { app, router } = createDashboardApp({ nuxtUi: ui })

void router.isReady().then(() => {
  app.mount("#app")
})
